import { createContext, useContext, useEffect, useState } from 'react'
import { useStateCallback } from 'hooks'
import { TireService } from 'lib/api/services/TireService'
import { useAuthStore } from 'context/AuthStore'

const INIT_TIRE_FILTER = {
  radiusFrom: null,
  radiusTo: null,
  heightFrom: null,
  heightTo: null,
  widthFrom: null,
  widthTo: null,
  season: null,
  studs: null,
  mark: null,
  hasRims: null
}

const TireFilterStoreContext = createContext({
  dictionary: {},
  store: {},
  func: {}
})

export const TireFilterStoreProvider = ({ prevFilter, ...props }) => {
  const { authStore } = useAuthStore()
  const [loading, setLoading] = useState(false)
  const [tireList, setTireList] = useState([])
  const [pagination, setPagination] = useState({ countFiltered: 0, offset: 0 })
  const [filter, setFilter] = useStateCallback(prevFilter || INIT_TIRE_FILTER)
  const [brands, setBrands] = useState([])

  useEffect(() => {
    TireService.getMarks().then(res => setBrands(res.data || []))
    getTireList()()
  }, [])

  const getTireList =
    (filterData = filter, offset) =>
    async () => {
      const payload = Object.keys(filterData).reduce((acc, key) => {
        const val = filterData[key]
        if (val !== undefined && val !== null && val !== '') acc[key] = val
        return acc
      }, {})
      payload.branchCode = authStore.user.branchList[0]
      payload.statusCode = 'on_sale'
      payload.setAmount = 4

      if (offset) payload.offset = offset

      setLoading(true)
      await TireService.getTireList(payload).then(res => {
        const data = res.data || {}
        setPagination({
          countFiltered: data.totalElement || 0,
          offset: typeof offset === 'number' ? offset : 0
        })
        setTireList(prev =>
          typeof offset === 'number'
            ? offset === 0
              ? data.content || []
              : [...prev, ...(data.content || [])]
            : data.content || []
        )
      })
      setLoading(false)
    }

  const onChangeFilter = (value = {}) => {
    setFilter(p => ({ ...p, ...value }))
  }

  const onChangeFilterChip = (value = {}) => {
    if (value?.studs) value.season = 'Зима шипы'
    setFilter(
      p => ({ ...p, ...value }),
      state => getTireList(state)()
    )
  }

  const onResetFilter = () => {
    setFilter({ ...INIT_TIRE_FILTER }, state => getTireList(state)())
  }

  const fetchMoreData = async () => {
    const offset = pagination.offset + 20
    setPagination(prev => ({ ...prev, offset }))
    await getTireList(undefined, offset)()
  }

  const store = {
    tireList,
    filter,
    loading,
    countFiltered: pagination.countFiltered,
    brands
  }

  const func = {
    fetchMoreData,
    onChangeFilter,
    onChangeFilterChip,
    onSearch: getTireList(filter),
    onResetFilter
  }

  return (
    <TireFilterStoreContext.Provider
      value={{
        dictionary: { brands },
        store,
        func
      }}
    >
      {props.children}
    </TireFilterStoreContext.Provider>
  )
}

export const useTireFilterStore = () => useContext(TireFilterStoreContext)
